import { BankOutlined, BranchesOutlined, FileOutlined, LogoutOutlined } from '@ant-design/icons'
import { useRedirect } from '@mbfab/frontend-common'
import { Layout, Menu } from 'antd'
import type { ItemType } from 'antd/es/menu/interface'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React from 'react'

import { Logo } from '../../components/ui/Logo'
import { routes } from '../../config/routes'

const Divider = () => <hr style={{ backgroundColor: 'white', opacity: 0.3, margin: 0 }}></hr>

export function AdminSider() {
  const redirect = useRedirect()
  const router = useRouter()
  const items: ItemType[] = []
  items.push({
    label: `テナント管理`,
    key: routes.adminTenants(),
    onClick: () => {
      redirect(routes.adminTenants())
    },
    icon: <BankOutlined />,
  })
  items.push({
    label: `プラン管理`,
    key: routes.adminPlans(),
    onClick: () => {
      redirect(routes.adminPlans())
    },
    icon: <FileOutlined />,
  })
  items.push({
    label: `通常画面へ`,
    key: routes.tenantSelectPath(),
    onClick: () => {
      redirect(routes.tenantSelectPath())
    },
    icon: <BranchesOutlined />,
  })

  items.push({
    label: `ログアウト`,
    key: '/sign_out',
    onClick: () => {
      redirect(routes.signOutPath())
    },
    icon: <LogoutOutlined />,
  })

  return (
    <Layout.Sider
      theme="light"
      style={{ fontWeight: 'bold', height: '100vh' }}
      className="dispaly-none-print overflow-hidden"
    >
      <div className="px-5 py-5 text-center">
        <Link href={routes.tenantSelectPath()}>
          <Logo />
        </Link>
      </div>
      <Divider />
      <Menu
        items={items}
        defaultSelectedKeys={[router.pathname]}
        selectedKeys={[router.pathname]}
        mode="inline"
        theme="light"
        style={{
          paddingTop: 12,
          paddingBottom: 30,
          height: 'calc(100vh - 170px)',
          overflow: 'scroll',
        }}
      />
    </Layout.Sider>
  )
}
